import { GetterTree } from 'vuex';
import { AccountState } from '@/store/modules/account/types';
import { RootState } from '@/store/types';

export const getters: GetterTree<AccountState, RootState> = {
  status: (state) => state.status,
  user: (state) => state.user,
  logoutMsg: (state) => state.logoutMsg
};
